/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {AfterContentInit, Attribute, ContentChildren, Directive, Input, QueryList, TemplateRef, ViewContainerRef} from '@angular/core';
import {isPresent} from '../facade/lang';
import {NgLocalization, getPluralCategory} from '../localization';
import {SwitchView} from './ng_switch';
export class NgPluralCase {
  /** @internal */
  _view: SwitchView;
  constructor( public value: string, template: TemplateRef<Object>,
      viewContainer: ViewContainerRef) {
    this._view = new SwitchView(viewContainer, template);
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngPluralCase]'}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: undefined, decorators: [{ type: Attribute, args: ['ngPluralCase', ] }, ]},
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}
export class NgPlural implements AfterContentInit {
  private _switchValue: number;
  private _activeView: SwitchView;
  private _caseViews: {[k: string]: SwitchView} = {}; cases: QueryList<NgPluralCase> = null;

  constructor(private _localization: NgLocalization) {}
  set ngPlural(value: number) {
    this._switchValue = value;
    this._updateView();
  }

  ngAfterContentInit() {
    this.cases.forEach((pluralCase: NgPluralCase): void => {
      this._caseViews[pluralCase.value] = pluralCase._view;
    });
    this._updateView();
  }

  /** @internal */
  _updateView(): void {
    this._clearViews();

    var key = getPluralCategory(
        this._switchValue, Object.getOwnPropertyNames(this._caseViews), this._localization);
    this._activateView(this._caseViews[key]);
  }

  /** @internal */
  _clearViews() {
    if (isPresent(this._activeView)) this._activeView.destroy();
  }

  /** @internal */
  _activateView(view: SwitchView) {
    if (!isPresent(view)) return;
    this._activeView = view;
    this._activeView.create();
  }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngPlural]'}, ] },
];
/** @nocollapse */
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: NgLocalization, },
];
/** @nocollapse */
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cases': [{ type: ContentChildren, args: [NgPluralCase, ] },],
'ngPlural': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
